/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  IndexRoute,
  Route,
} from 'react-router';
import Billing from '../Billing';
import Balogs from '../Billing/Balogs';
import BillLogs from '../Billing/BillLogs';
import BillDetail from '../Billing/BillDetail';
import Recharge from '../Billing/Recharge';

const BillingRoutes = (
  <Route path="billing">
    <IndexRoute component={Billing} />
    <Route path="balogs" component={Balogs} />
    <Route path="billlogs" component={BillLogs} />
    <Route path="billdetail" component={BillDetail} />
    <Route path="recharge" component={Recharge} />
    <Route path="plans" component={Billing} />
  </Route>
);

export default BillingRoutes;




// WEBPACK FOOTER //
// ./src/containers/Routes/BillingRoutes.jsx